<template>
  <div>
    <custom-head :item="item" :type="type" @deleteItem="(item) => deleteItem(item)">
      <div>
        <a-tabs
          style="width: 100%"
          :value="tabValue"
          size="small"
          @change="(value) => chagneTab(value)"
        >
          <template v-for="tab in tabList">
            <a-tab-pane :key="tab.key" :tab="tab.name"> </a-tab-pane>
          </template>
        </a-tabs>
      </div>
    </custom-head>
    <div class="map-view-box">
      <div v-if="tabValue!=='4'" style="display: flex;">
        <a-select
          :value="dataValue"
          style="margin-left: 8px;width: 150px"
          @change="(value) => changeData(value)"
        >
          <template v-for="(item, index) in dataList">
            <a-select-option :key="index" :value="item.value">
              {{ item.name }}
            </a-select-option>
          </template>
        </a-select>
        <a-select
          v-if="tabValue=='2'"
          v-model="issueType"
          style="margin-left: 8px;width: 150px"
          @change="changeIssueType"
        >
          <template v-for="(item, index) in issueTypeOptions">
            <a-select-option :key="index" :value="item.value">
              {{ item.name }}
            </a-select-option>
          </template>
        </a-select>
      </div>
      <div v-else style="height: 34px;"></div>
      <div style="width:100%;height:100%" :id="'map-view' + id"></div>
    </div>
  </div>
</template>

<script>
import mixin from './cardmixin.vue'
import china from '../utils/china.json'
import {
  MdcCardServiceProxy,
  AlarmHistoryServiceProxy
} from '@/service-proxies/app-v2/mdc.service-proxies'
import { MachineServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { WorkRecordStatisticsServiceProxy} from '@/service-proxies/app-v2/work-record.service-proxies'
import dayjs from 'dayjs'
const scsp = new MdcCardServiceProxy()
const ahsp = new AlarmHistoryServiceProxy()
const msp = new MachineServiceProxy()
const workRecordStatics =  new WorkRecordStatisticsServiceProxy()
const chinaGeoCoordMap = {
  黑龙江省: [127.9688, 45.368],
  内蒙古自治区: [110.3467, 41.4899],
  吉林省: [125.8154, 44.2584],
  北京市: [116.4551, 40.2539],
  辽宁省: [123.1238, 42.1216],
  河北省: [114.4995, 38.1006],
  天津市: [117.4219, 39.1189],
  山西省: [111.3352, 37.0413],
  陕西省: [107.3162, 33.8004],
  甘肃省: [103.5901, 36.3043],
  宁夏回族自治区: [106.3586, 38.1775],
  青海省: [95.4038, 36.8207],
  新疆维吾尔自治区: [87.9236, 43.5883],
  西藏自治区: [91.11, 29.97],
  四川省: [100.9526, 30.7617],
  重庆市: [108.384366, 30.439702],
  山东省: [117.1582, 36.8701],
  河南省: [113.4668, 34.6234],
  江苏省: [118.8062, 33.9208],
  安徽省: [117.29, 32.0581],
  湖北省: [114.3896, 30.6628],
  浙江省: [119.5313, 29.8773],
  福建省: [119.4543, 25.9222],
  江西省: [116.0046, 28.6633],
  湖南省: [111.0823, 28.2568],
  贵州省: [106.6992, 26.7682],
  云南省: [102.9199, 25.4663],
  广东省: [113.12244, 23.009505],
  广西壮族自治区: [108.479, 23.1152],
  海南省: [110.3893, 19.8516],
  上海市: [121.4648, 31.2891],
  南海诸岛: [126.54909, 21.998951],
  台湾省: [121.509062, 25.044332],
  澳门特别行政区: [113.54909, 21.998951],
  香港特别行政区: [114.173355, 22.320048]
}

const mapJian = [
  {
    key: '黑龙江省',
    value: '黑'
  },
  {
    key: '内蒙古自治区',
    value: '蒙'
  },
  {
    key: '吉林省',
    value: '吉'
  },
  {
    key: '北京市',
    value: '京'
  },
  {
    key: '辽宁省',
    value: '辽'
  },
  {
    key: '河北省',
    value: '冀'
  },
  {
    key: '天津市',
    value: '津'
  },
  {
    key: '山西省',
    value: '晋'
  },
  {
    key: '陕西省',
    value: '陕'
  },
  {
    key: '甘肃省',
    value: '甘'
  },
  {
    key: '宁夏回族自治区',
    value: '宁'
  },
  {
    key: '青海省',
    value: '青'
  },
  {
    key: '新疆维吾尔自治区',
    value: '新'
  },
  {
    key: '西藏自治区',
    value: '藏'
  },
  {
    key: '四川省',
    value: '川'
  },
  {
    key: '重庆市',
    value: '渝'
  },
  {
    key: '山东省',
    value: '鲁'
  },
  {
    key: '河南省',
    value: '豫'
  },
  {
    key: '江苏省',
    value: '苏'
  },
  {
    key: '安徽省',
    value: '皖'
  },
  {
    key: '湖北省',
    value: '鄂'
  },
  {
    key: '浙江省',
    value: '浙'
  },
  {
    key: '福建省',
    value: '闽'
  },
  {
    key: '江西省',
    value: '赣'
  },
  {
    key: '湖南省',
    value: '湘'
  },
  {
    key: '贵州省',
    value: '贵'
  },
  {
    key: '云南省',
    value: '云'
  },
  {
    key: '广东省',
    value: '粤'
  },
  {
    key: '广西壮族自治区',
    value: '桂'
  },
  {
    key: '海南省',
    value: '琼'
  },
  {
    key: '上海市',
    value: '沪'
  },
  {
    key: '南海诸岛',
    value: '南海诸岛'
  },
  {
    key: '台湾省',
    value: '台'
  },
  {
    key: '澳门特别行政区',
    value: '澳'
  },
  {
    key: '香港特别行政区',
    value: '港'
  }
]

export default {
  name: 'map-view',
  mixins: [mixin],
  data() {
    return {
      myChart: null,
      echartData: [],
      tabValue: '1',
      geoValue1: [
        {
          gt: 1000,
          label: '1000以上',
          color: '#FF3B58'
        },
        {
          gte: 500,
          lte: 1000,
          label: '500 - 1000',
          color: '#b400ff'
        },
        {
          gte: 200,
          lte: 500,
          label: '200 - 500',
          color: '#d85dff'
        },
        {
          gte: 100,
          lte: 200,
          label: '100 - 200',
          color: '#1784ff'
        },
        {
          gte: 50,
          lte: 100,
          label: '50 - 100',
          color: '#5bafff'
        },
        {
          gte: 20,
          lte: 50,
          label: '20 - 50',
          color: '#27c0ff'
        },
        {
          gte: 5,
          lte: 20,
          label: '5 - 20',
          color: '#2dd8ff'
        },
        {
          gte: 0,
          lte: 5,
          label: '0 - 5',
          color: '#36f7df'
        }
      ],
      geoValue2: [
        {
          gte: 70,
          lte: 100,
          label: '70% - 100%',
          color: '#b400ff'
        },
        {
          gte: 45,
          lte: 70,
          label: '45% - 70%',
          color: '#d85dff'
        },
        {
          gte: 35,
          lte: 45,
          label: '35% - 45%',
          color: '#1784ff'
        },
        {
          gte: 25,
          lte: 35,
          label: '25% - 35%',
          color: '#5bafff'
        },
        {
          gte: 15,
          lte: 25,
          label: '15% - 25%',
          color: '#27c0ff'
        },
        {
          gte: 5,
          lte: 15,
          label: '5% - 15%',
          color: '#2dd8ff'
        },
        {
          gte: 0,
          lte: 5,
          label: '0% - 5%',
          color: '#36f7df'
        }
      ],
      dataValue: '1',
      issueType: '1',
      alarmVisual: [
        {
          gt: 100000,
          label: '100k以上',
          color: '#FF3B58'
        },
        {
          gte: 50000,
          lte: 100000,
          label: '50k - 100k',
          color: '#b400ff'
        },
        {
          gte: 20000,
          lte: 50000,
          label: '20k - 50k',
          color: '#d85dff'
        },
        {
          gte: 10000,
          lte: 20000,
          label: '10k - 20k',
          color: '#1784ff'
        },
        {
          gte: 5000,
          lte: 10000,
          label: '5k - 10k',
          color: '#5bafff'
        },
        {
          gte: 2000,
          lte: 5000,
          label: '2k - 5k',
          color: '#27c0ff'
        },
        {
          gte: 1000,
          lte: 2000,
          label: '1k - 2k',
          color: '#2dd8ff'
        },
        {
          gte: 0,
          lte: 1000,
          label: '0 - 1k',
          color: '#36f7df'
        }
      ]
    }
  },
  props: {
    unit: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    const idName = 'map-view' + this.id
    this.myChart = this.$echarts.init(document.getElementById(idName))
    this.$echarts.registerMap('china', china)
    this.chagneTab('1')
  },
  watch: {
    chartOption: {
      handler(val) {
        if (this.myChart) {
          this.myChart.setOption(val, true)
          // this.myChart.resize()
        }
      },
      deep: true,
      immediate: true
    },
    unit: {
      handler() {
        if (this.myChart) {
          setTimeout(() => {
            this.myChart.resize()
          }, 300)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    chartOption() {
      let title = this.tabList.find((res) => res.key === this.tabValue).name
      let option = {
        tooltip: {
          triggerOn: 'mousemove|click',
          formatter: function(e, t, n) {
            return 0.5 == e.value
              ? e.name + `：${title}`
              : e.seriesName + '<br />' + e.name + '：' + (e.value ? e.value : 0)
          }
        },
        visualMap: {
          min: 0,
          left: 10,
          bottom: 0,
          showLabel: true,
          pieces: this.tabValue === '2' ? this.alarmVisual : ( this.tabValue === '3'? this.geoValue2 : this.geoValue1 ),
          show: true
        },
        geo: {
          show: true,
          map: 'china',
          roam: true,
          scaleLimit: {
            min: 1.23,
            max: 1.23
          },
          zoom: 1.23,
          top: 60,
          label: {
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              borderColor: '#fff'
            },
            normal: {
              areaColor: '#141D29',
              borderColor: '#fff'
            },
            emphasis: {
              areaColor: '#f2d5ad',
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0
            }
          }
        },
        series: [
          {
            name: title,
            type: 'map',
            geoIndex: 0,
            label: {
              color: '#fff',
              show: false
            },
            itemStyle: {
              areaColor: '#fff',
              borderWidth: 1,
              borderColor: '#fff'
            },
            emphasis: {
              label: {
                show: false
              },
              itemStyle: {
                areaColor: '#fff'
              }
            },
            data: this.echartData
          },
          {
            name: '散点',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: this.convertData(this.echartData),
            zlevel: 100,
            symbolSize: 5,
            colorBy: 'data',
            selectedMode: false,
            rippleEffect: {
              number: 1,
              period: 4
            },
            label: {
              formatter: (params) => {
                if(params.value[2]===0) {
                  return '';
                } else {
                  // 机床数量和未完成工单
                  if(['1', '4'].includes(this.tabValue)) {
                    return this.showName(params.name) + ' : ' + params.value[2] + '('+  params.data.subValue +')'
                  }
                  // 稼动率
                  if(this.tabValue === '3') {
                    return this.showName(params.name) + ' : ' + params.value[2] + '%'
                  }
                  // 报警
                  if(this.tabValue === '2') {
                    return this.showName(params.name) + ' : ' + params.value[2]
                  } 
                }
              },
              show: true,
              position: 'right',
              fontSize: 12,
              color: '#333333',
              textBorderWidth: 2,
              textBorderType: 'solid',
              textBorderColor: 'inherit',
            },
            tooltip: {
              show: false
            }
          }
        ]
      }
      return option
    },
    dataList() {
      if(['1', '4'].includes(this.tabValue)) {
        return this.dataList1;
      } else {
        return this.dataList2;
      }
    },
    tabList() {
      return [
        {
          key: '1',
          name: this.$t('page_province_machine_num')
        },
        {
          key: '2',
          name: this.$t('page_province_alarm_num')
        },
        {
          key: '3',
          name: this.$t('page_province_machine_OEE')
        },
        {
          key: '4',
          name: this.$t('province_not_completed')
        }
      ]
    },
    dataList1() {
      return [{
        value: 'all',
        name: this.$t('page_all')
        },
        {
          value: '1',
          name: this.$t('page_last_1_month')
        },
        {
          value: '3',
          name: this.$t('page_last_3_month')
        },
        {
          value: '6',
          name: this.$t('page_last_6_month')
        },
        {
          value: '12',
          name: this.$t('page_last_1_year')
        },
        {
          value: '24',
          name: this.$t('page_last_2_year')
        }]
    },
    dataList2() {
      return [
        {
          value: '1',
          name: this.$t('page_last_1_month')
        },
        {
          value: '3',
          name: this.$t('page_last_3_month')
        },
        {
          value: '6',
          name: this.$t('page_last_6_month')
        },
        {
          value: '12',
          name: this.$t('page_last_1_year')
        },
        {
          value: '24',
          name: this.$t('page_last_2_year')
        }
      ]
    },
    issueTypeOptions() {
      // 0: 全部 1:错误 2:警告 3:提示
      return [
        {
          value: '',
          name: this.$t('page_all')
        },
        {
          value: '1',
          name: this.$t('page_error')
        },
        {
          value: '2',
          name: this.$t('page_warning')
        },
        {
          value: '3',
          name: this.$t('page_tip')
        },
      ]
    },
  },
  methods: {
    showName(name) {
      let val = ''
      const jian = mapJian.find((res) => res.key === name)
      if (jian) {
        val = jian.value
      }
      return val
    },
    changeData(value) {
      this.dataValue = value
      const dto = value === 'all'?{}:{
        endTime: dayjs().format('YYYY-MM-DD'),
        startTime: dayjs()
          .subtract(value, 'month')
          .format('YYYY-MM-DD')
      }
      if(this.tabValue==='4') {
        workRecordStatics.getProvinceUnfinishedWorkRecordStatistics(dto).then(res=>{
          const data = res?.map(v=>{
            v.value = v.totalValue;
            v.subValue = v.unfinishedValue;
            return v;
          });
          this.echartData = [...data, ...[{name: '南海诸岛', value: 0}]];
        })
      } else if (this.tabValue === '3') {
        scsp.getProvinceOeeStatistics(dto).then((res) => {
          res.push({name: '南海诸岛', value: 0});
          this.echartData = res
        })
      } else if (this.tabValue === '2') {
        ahsp.getProvinceAlarmStatistics({...dto,...{issueType: this.issueType}}).then((res) => {
          res.push({name: '南海诸岛', value: 0});
          this.echartData = res
        })
      }else if (this.tabValue === '1') {
        msp.getProvinceMachineStatistics(dto).then((res) => {
          const data = res?.map(v=>{
            v.value = v.totalValue;
            v.subValue = v.machineValue;
            return v;
          });
          this.echartData = [...data, ...[{name: '南海诸岛', value: 0}]];

        })
      }
      this.$nextTick(() => {
        this.myChart.setOption(this.chartOption)
      })
    },
    changeIssueType() {
      const time = this.dataValue === 'all'?{}:{
        endTime: dayjs().format('YYYY-MM-DD'),
        startTime: dayjs()
          .subtract(this.dataValue, 'month')
          .format('YYYY-MM-DD')
      }
      ahsp.getProvinceAlarmStatistics({...time,...{issueType: this.issueType}}).then((res) => {
        res.push({name: '南海诸岛', value: 0});
        this.echartData = res
      })
    },
    convertData(data) {
      let result = []
      result = data.map((item) => {
        return {
          ...item,
          value: chinaGeoCoordMap[item.name]
            ? chinaGeoCoordMap[item.name].concat(item.value)
            : [1000, 1000, 10]
        }
      })
      return result
    },
    chagneTab(value) {
      this.tabValue = value
      const type = ['1', '4'].includes(value)? 'all' : '1';
      this.echartData = [];
      this.changeData(type)
    },
    getName(value) {
      return value.charAt(0)
    }
  }
}
</script>

<style lang="less" scoped>
.map-view-box {
  width: 100%;
  height: 100%;
  overflow-x: auto;
  display: flex !important;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: flex-start;
  .map-view-legend {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    &-index {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      align-content: center;
      padding: 4px 0;
    }
    &-icon {
      width: 10px;
      height: 10px;
      border-radius: 5px;
    }
    &-name {
      font-size: 16px;
      padding: 0 20px 0 10px;
      color: #666666;
    }
    &-value {
      font-size: 24px;
      line-height: 24px;
      font-weight: 500;
    }
  }
}
/deep/ .ant-tabs {
  overflow: inherit;
}

/deep/ .ant-tabs-bar {
  bottom: -1px;
  border-bottom: 1px solid #d9d9d9;
}

/deep/ .ant-tabs .ant-tabs-small-bar .ant-tabs-tab {
  padding: 9px 16px 8px;
  margin: 0;
}
/deep/ .ant-tabs-nav .ant-tabs-tab {
  border-right: 1px solid #d9d9d9;
}

/deep/ .ant-tabs-nav .ant-tabs-tab-active {
  background-color: #fff;
}

/deep/ .ant-tabs-ink-bar {
  top: -1px !important;
  z-index: 99;
  background-color: #4a90e2;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  bottom: auto;
  height: 4px;
}
::-webkit-scrollbar {
  width: 0;
}
</style>
